import { useFocusManager } from '@react-aria/focus'
import { FC, Children, cloneElement, ReactElement } from 'react'
import { Tooltip } from 'components/Tooltip/Tooltip'

import { ControlProps } from './Types'

const Control: FC<React.PropsWithChildren<ControlProps>> = ({
  excludeFromTabOrder,
  tooltipTitle,
  tooltipPlacement = 'top',
  children,
}) => {
  const focusManager = useFocusManager()

  const onKeyDown = (e: KeyboardEvent) => {
    switch (e.key) {
      case 'ArrowRight':
        focusManager?.focusNext({ wrap: true })
        break
      case 'ArrowLeft':
        focusManager?.focusPrevious({ wrap: true })
        break
    }
  }

  const child = Children.only(children)
  if (!child) return null

  const controlComponent = cloneElement(child as ReactElement, {
    ...(child as ReactElement).props,
    excludeFromTabOrder,
    onKeyDown,
  })

  return (
    <Tooltip label={tooltipTitle} placement={tooltipPlacement} hide={!tooltipTitle}>
      <span>{controlComponent}</span>
    </Tooltip>
  )
}

export { Control }
